import { useCloudId } from '@atlassian/jira-tenant-context-controller';
import { useBacklogSelector } from '../../../state';
import { getProjectName, projectIdSelector } from '../../../state/selectors/app';
import { useGetSpaceKey } from './utils';

export const useCoUseFlow = (coUseEligible: boolean): string => {
	// Extract project name and project id
	const projectName = useBacklogSelector(getProjectName);
	const projectId = useBacklogSelector(projectIdSelector);

	const spaceKey = useGetSpaceKey(projectName, coUseEligible);

	const cloudId = useCloudId();

	return `/wiki/create-content/whiteboard?openJiraImportTool=true&cloudId=${cloudId}&projectUuid=${projectId}&insertTemplateWithKey=prioritization-experiment&spaceKey=${spaceKey}&withFallback=True`;
};
